import { Component, effect, input, signal } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { Course, RubricLevelsBySkill } from '@mira-avant/mtlibs';
import { RubricService } from '../../../../services/rubric.service';

@Component({
	selector: 'app-rubric-content-levels-report',
	standalone: true,
	imports: [AngularModule, ZorroModule],
	templateUrl: './rubric-content-levels-report.component.html',
	styleUrl: './rubric-content-levels-report.component.scss',
})
export class RubricContentLevelsReportComponent {
	// Input as signal
	readonly course = input<Course | undefined>();

	// Reactive state
	readonly contentLevels = signal<RubricLevelsBySkill[]>([]);
	readonly isLoading = signal<boolean>(true);
	readonly rubricCode = signal<string | undefined>(undefined);

	constructor(public rubricService: RubricService) {
		// React to course input changes
		effect(async () => {
			const currentCourse = this.course();

			if (!currentCourse || !currentCourse.rubric_code) {
				this.contentLevels.set([]);
				this.isLoading.set(false);
				return;
			}

			try {
				this.rubricCode.set(currentCourse.rubric_code);

				const levels = await this.rubricService.getRubricContentLevels$(
					currentCourse.rubric_code,
					currentCourse.uuid
				);

				this.contentLevels.set(levels);
			} catch (error) {
				console.error('Error loading rubric content levels:', error);
				this.contentLevels.set([]);
			} finally {
				this.isLoading.set(false);
			}
		});
	}
}
